// DataContext.js
import { createContext, useContext, useState } from 'react';

// 1. Create the Context object
export const DataContext = createContext(null);

// 2. Create a custom Provider component
export function DataProvider({ children }) {
  
  const [dataAll, setDataAll] = useState(null);

  const updateDataAll = x =>{
    console.log(x)
    setDataAll(x)
  }

  return (
    <DataContext.Provider value={{ dataAll, setDataAll,updateDataAll}}>
      {children}
    </DataContext.Provider>
  );
}

//3. Create custom Hook for accessing DataProvider

export function useData() {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
}